import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.listCacheRules;

type CacheRulesQueryData = NonNullable<
  Awaited<ReturnType<typeof apiFn>>['data']
>['items'];

type CacheRulesParams = Omit<
  Parameters<typeof apiFn>[0],
  'pageLimit' | 'pageCursor'
>;

const DBO_CACHE_RULES_V2_QUERY_KEY = 'dbo-cache-rules-v2';

export const getCacheRulesQueryKey = (params?: CacheRulesParams) =>
  params
    ? ([DBO_CACHE_RULES_V2_QUERY_KEY, params] as const)
    : ([DBO_CACHE_RULES_V2_QUERY_KEY] as const);

export const useCacheRulesQuery = <SELECT = CacheRulesQueryData>({
  enabled = true,
  select,
  refetchInterval,
  ...params
}: CacheRulesParams & {
  enabled?: boolean;
  select?: (data: CacheRulesQueryData) => SELECT;
  refetchInterval?: number;
}) =>
  useQuery(
    queryOptions({
      queryKey: getCacheRulesQueryKey(params),
      queryFn: async () => (await apiFn(params)).data.items ?? [],
      enabled: makeIsEnabled(
        !!params.organizationId,
        !!params.proxyId,
        !!params.databaseName,
        enabled
      ),
      select,
      refetchInterval,
    })
  );
